import React from "react";
import AddIcon from "@mui/icons-material/Add";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import Disclaimer from "modules/common/components/disclaimer";
import MultiSelectCalloutWithSearch from "modules/common/components/forms/inputs/multiSelectCalloutWithSearch";
import { Audience, SimpleAudience } from "modules/audiences";
import ChipListWithButton from "modules/common/components/ChipsListWithButton";

import "../components/messaging/messagingSMSControls.sass";

interface IAutomaticSubscriptionsProps {
    audiences: Audience[];
    automaticOptInAudiences: SimpleAudience[];
    isFetching: boolean;
    setAutomaticOptInAudiences: (audiences: string[]) => any;
    getAudienceUsersCSV: (audienceIds: string[], filename: string) => void;
}

const AutomaticSubscriptionAudiencesSection: React.FC<IAutomaticSubscriptionsProps> = ({
    audiences,
    automaticOptInAudiences,
    isFetching,
    setAutomaticOptInAudiences,
    getAudienceUsersCSV
}) => {
    return (
        <div className="sms-section">
            <div className="text-section">
                <div className="title-and-description">
                    <b className="title">Audiences for Automatic SMS Subscription</b>   
                    <p className="description">Select the audiences whose users will be automatically subscribed and opted in to receive SMS notifications.</p>
                </div>
                {audiences.length !== 0 &&
                    <MultiSelectCalloutWithSearch
                        defaultOptions={audiences.map(opt => ({id: opt.id, name: opt.displayName}))}
                        containerClassName={"settings-title-button"}
                        selectedOptions={automaticOptInAudiences}
                        onChange={(audiences) => setAutomaticOptInAudiences(audiences.map(a => a.id))}
                        buttonStyle={{
                            startIcon: <AddIcon/>,
                            buttonText: "Add/Edit Audiences"
                        }}
                        nestingAllowed={false}
                        searchBarText={"Search audiences"}
                        buttonId={"select-opt-in-audiences-button"}
                    />
                }
            </div>
            <Disclaimer
                icon={<InfoOutlinedIcon />}
                text={
                <React.Fragment>
                    <div>
                        <span>
                            By automatically subscribing the users within the selected audiences to SMS on behalf of your organization,
                            you assume responsibility for compliance with applicable privacy regulations. 
                            Please ensure your actions align with privacy regulations before overriding user consent.
                        </span>
                    </div>
                </React.Fragment>
                }
            />
            <div className="chip-section">
                {automaticOptInAudiences.length > 0
                    ? <ChipListWithButton 
                        downloadText="Download CSV"
                        isFetching={isFetching}
                        items={automaticOptInAudiences}
                        onClick={() => getAudienceUsersCSV(automaticOptInAudiences.map(f => f.id), `autosubscribed_list.csv`)}
                        onChipClose={(audience) => setAutomaticOptInAudiences(automaticOptInAudiences.map(a => a.id).filter(a => a !== audience.id))}
                    />
                    : <p className="description" style={{fontStyle: "italic"}}>No audiences are set for automatic SMS subscription</p>
                }
            </div>
        </div>
    );
}

export default AutomaticSubscriptionAudiencesSection;